import { render, staticRenderFns } from "./ExtendedSidebar.vue?vue&type=template&id=9ce35498&scoped=true&"
import script from "./ExtendedSidebar.vue?vue&type=script&lang=js&"
export * from "./ExtendedSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ExtendedSidebar.vue?vue&type=style&index=0&id=9ce35498&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ce35498",
  null
  
)

export default component.exports